import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { removeUser } from '../../actions';
import { withFirebase } from '../../services/firebase';

import SignOut from '../../components/SignOut';

class SignOutContainer extends Component {
  handleSignOut = () => {
    const { firebase, removeUser } = this.props;

    firebase
      .signOut()
      .then(() => {
        removeUser();
        // history.push('/vi/signup');
      })
      .catch(error => console.log(error.message));
  };

  render() {
    const { t } = this.props;
    return <SignOut handleSignOut={this.handleSignOut} t={t}/>;
  }
}

export default compose(
  connect(null, { removeUser }),
  withFirebase
)(SignOutContainer);
